module.exports = __webpack_public_path__ + "img/extract_enable.67837377.svg";